"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitOverlappingFeatures = exports.getOverlappingIndices = exports.findOverlappingFeatures = void 0;
const turf = __importStar(require("@turf/turf"));
// TODO Can we type this?
const getComparisonMethod = (feature) => {
    if (feature.geometry.type === 'LineString') {
        return (a, b) => turf.booleanPointOnLine(a, b, {});
    }
    if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon') {
        return (a, b) => turf.booleanPointInPolygon(a, b, { ignoreBoundary: false });
    }
    if (feature.geometry.type === 'MultiLineString') {
        return (point, multiLineStringFeature) => {
            const singleLineStringsFeatureCollection = turf.flatten(multiLineStringFeature);
            for (let i = 0, count = singleLineStringsFeatureCollection.features.length; i < count; i++) {
                if (turf.booleanPointOnLine(point, singleLineStringsFeatureCollection.features[i])) {
                    return true;
                }
            }
            return false;
        };
    }
    return (_a, _b) => false;
};
const findOverlappingFeatures = (feature, features, options = { not: false }) => {
    if (feature.geometry.type === 'GeometryCollection') {
        console.log('findOverlappingFeature does not process geometries of type GeometryCollection');
        return [];
    }
    const indices = (0, exports.getOverlappingIndices)(feature, features);
    return features.filter((f, index) => {
        const overlaps = indices.includes(index);
        return options.not ? !overlaps : overlaps;
    });
};
exports.findOverlappingFeatures = findOverlappingFeatures;
const getOverlappingIndices = (feature, featureToSplit) => {
    // TODO: Start by splitting the feature in the bounding box, to avoid
    // lengthy calculation for far away features
    const comparisonMethod = getComparisonMethod(feature);
    if (!comparisonMethod) {
        console.warn('Cannot find overlapping geometries for feature type ', feature.geometry);
        return [];
    }
    const overlappingIndices = [];
    featureToSplit.forEach((toCompare, index) => {
        if (toCompare.geometry.type !== 'Point' &&
            toCompare.geometry.type !== 'MultiPoint' &&
            toCompare.geometry.type !== 'GeometryCollection') {
            try {
                if (toCompare.geometry.type === feature.geometry.type &&
                    turf.booleanOverlap(toCompare.geometry, feature.geometry)) {
                    overlappingIndices.push(index);
                }
                else if (
                // The booleanDisjoint call supports more geometries than other turf functions, especially multi* features
                !turf.booleanDisjoint(toCompare.geometry, feature.geometry)) {
                    overlappingIndices.push(index);
                }
            }
            catch (_c) {
                // Unsupported geometry in overlap or within, just ignore instead of checking all types
            }
        }
        else if (comparisonMethod(toCompare.geometry, feature.geometry)) {
            overlappingIndices.push(index);
        }
    });
    return overlappingIndices;
};
exports.getOverlappingIndices = getOverlappingIndices;
const splitOverlapping = (featuresToSplit, overlappingIndices) => {
    const overlapping = [];
    const notOverlapping = [];
    featuresToSplit.forEach((feature, index) => {
        if (overlappingIndices.includes(index)) {
            overlapping.push(feature);
        }
        else {
            notOverlapping.push(feature);
        }
    });
    return { overlapping, notOverlapping };
};
const getFeatureCount = (features, indices, featureCount) => {
    let count = 0;
    indices.forEach((index) => (count += featureCount(features[index])));
    return count;
};
const getOverlappingOnConvex = (feature, featuresToSplit) => {
    const convexFeature = turf.convex(turf.explode(feature));
    if (convexFeature === feature) {
        console.log('Convex feature equivalent to feature');
    }
    else if (convexFeature === null) {
        return [];
    }
    return (0, exports.getOverlappingIndices)(convexFeature, featuresToSplit);
};
const getOverlappingOnBuffer = (originalFeature, options, featuresToSplit) => {
    // Do 4 buffer iterations to find the best count
    let diff = options.maxBufferSize;
    let buffer = 0;
    let i = 0;
    let bestApproximation = options.overlappingIndices;
    let bestCount = options.bestCount;
    let lastCount = bestCount;
    while (i < 7 && bestCount !== options.expectedApproximateCount) {
        diff = diff / 2;
        buffer = lastCount < options.expectedApproximateCount ? buffer + diff : buffer - diff;
        const bufferedFeature = turf.buffer(originalFeature, buffer / 1000);
        if (!bufferedFeature || bufferedFeature.geometry === null) {
            break;
        }
        const lastIndices = (0, exports.getOverlappingIndices)(bufferedFeature, featuresToSplit);
        lastCount =
            lastIndices.length > bestApproximation.length
                ? getFeatureCount(featuresToSplit, lastIndices, options.featureCount)
                : bestCount;
        if (lastCount <= options.expectedApproximateCount && lastCount > bestCount) {
            bestCount = lastCount;
            bestApproximation = lastIndices;
        }
        i++;
    }
    return bestApproximation;
};
/** Max buffer size is the minimal distance between features - 1 in meters */
const getMaxBufferSize = (feature, featuresToSplit) => {
    // First, to get a max buffer size, do a square root of the area of the
    // feature, that should give a good enough first approximation, even if the
    // shape is not a square.
    const area = turf.area(feature);
    const defaultBufferSizeInMeters = Math.sqrt(area);
    if (featuresToSplit.length <= 1) {
        return defaultBufferSizeInMeters;
    }
    // Then to avoid having too large buffers for large shape, we filter the
    // feature on a buffer of the size of the shape, then calculate the smallest
    // distance between features in that area as the buffer size.
    const bufferedShape = turf.buffer(feature, defaultBufferSizeInMeters / 1000);
    if (!bufferedShape || bufferedShape.geometry === null) {
        return defaultBufferSizeInMeters;
    }
    const splitSubset = (0, exports.getOverlappingIndices)(bufferedShape, featuresToSplit);
    let minDistance = defaultBufferSizeInMeters; // in meters
    for (let i = 0, len = splitSubset.length; i < len - 1; i++) {
        for (let j = i + 1; j < len; j++) {
            minDistance = Math.min(minDistance, turf.distance(turf.pointOnFeature(featuresToSplit[splitSubset[i]]), turf.pointOnFeature(featuresToSplit[splitSubset[j]])) * 1000);
        }
    }
    return Math.max(1, Math.floor(minDistance));
};
/**
 * Split the features between those that overlap and those that do not. Each
 * element in the original array is in one the returned arrays.
 * @param feature The feature to overlap
 * @param featureToSplit The feature array to split
 */
const splitOverlappingFeatures = (feature, featuresToSplit, options = {
    expectedApproximateCount: 0,
    featureCount: (_feature) => 1,
    allowConvex: true,
    allowBuffer: true,
    maxBufferSize: undefined
}) => {
    const filteredFeatures = featuresToSplit.filter((f) => f.geometry.type !== 'GeometryCollection');
    if (feature.geometry.type === 'GeometryCollection') {
        console.log('splitOverlappingFeatures does not process geometries of type GeometryCollection');
        return { overlapping: [], notOverlapping: filteredFeatures };
    }
    const geometryFeature = feature;
    const expectedApproximateCount = options.expectedApproximateCount || 0;
    const featureCount = options.featureCount || (() => 1);
    const allowConvex = options.allowConvex === undefined ? true : options.allowConvex;
    const allowBuffer = options.allowBuffer === undefined ? true : options.allowBuffer;
    const overlappingIndices = (0, exports.getOverlappingIndices)(geometryFeature, filteredFeatures);
    // No count check, fast return
    if (expectedApproximateCount <= 0) {
        return splitOverlapping(filteredFeatures, overlappingIndices);
    }
    const countOverlapping = getFeatureCount(filteredFeatures, overlappingIndices, featureCount);
    if (countOverlapping < expectedApproximateCount && (allowConvex || allowBuffer)) {
        // Try splitting on the convex hull
        let overlappingConvexIndices = allowConvex
            ? getOverlappingOnConvex(geometryFeature, filteredFeatures)
            : overlappingIndices;
        if (allowConvex) {
            const countOverlappingConvex = overlappingConvexIndices.length > overlappingIndices.length
                ? getFeatureCount(filteredFeatures, overlappingConvexIndices, featureCount)
                : countOverlapping;
            if (countOverlappingConvex === expectedApproximateCount) {
                return splitOverlapping(filteredFeatures, overlappingConvexIndices);
            }
            else if (countOverlappingConvex > expectedApproximateCount) {
                overlappingConvexIndices = overlappingIndices;
            }
        }
        // Try splitting with a buffer
        if (allowBuffer) {
            const realMaxBufferSize = options.maxBufferSize
                ? options.maxBufferSize
                : getMaxBufferSize(geometryFeature, filteredFeatures);
            const overlappingOnBufferIndices = getOverlappingOnBuffer(geometryFeature, {
                expectedApproximateCount,
                featureCount,
                maxBufferSize: realMaxBufferSize,
                overlappingIndices,
                bestCount: countOverlapping
            }, filteredFeatures);
            const countOverlappingBuffer = overlappingOnBufferIndices.length > overlappingIndices.length
                ? getFeatureCount(filteredFeatures, overlappingOnBufferIndices, featureCount)
                : countOverlapping;
            if (countOverlappingBuffer === expectedApproximateCount) {
                return splitOverlapping(filteredFeatures, overlappingOnBufferIndices);
            }
            // See if convex + buffer has better result
            const overlappingBufferConvexIndices = Object.assign([], overlappingOnBufferIndices);
            overlappingConvexIndices.forEach((i) => {
                if (!overlappingBufferConvexIndices.includes(i)) {
                    overlappingBufferConvexIndices.push(i);
                }
            });
            const countOverlappingBufferConvex = overlappingBufferConvexIndices.length > overlappingIndices.length
                ? getFeatureCount(filteredFeatures, overlappingBufferConvexIndices, featureCount)
                : countOverlapping;
            return splitOverlapping(filteredFeatures, countOverlappingBufferConvex <= expectedApproximateCount
                ? overlappingBufferConvexIndices
                : overlappingOnBufferIndices);
        }
        return splitOverlapping(filteredFeatures, overlappingConvexIndices);
    }
    return splitOverlapping(filteredFeatures, overlappingIndices);
};
exports.splitOverlappingFeatures = splitOverlappingFeatures;
//# sourceMappingURL=FindOverlappingFeatures.js.map